import { DownloadIcon } from "~/icons/DownloadIcon";

type FileItem = {
  icon?: React.ReactNode;
  text: string;
  url: string;
};

type DownloadSectionProps = {
  items: FileItem[];
};

export function DownloadSection({ items }: DownloadSectionProps) {
  return (
    <section>
      <div className={`grid grid-cols-1 gap-4 ${items.length > 3 ? 'sm:grid-cols-2' : ''}`}>
        {Array.from({ length: Math.ceil(items.length / 3) }, (_, i) => {
          const group = items.slice(i * 3, i * 3 + 3);

          return (
            <div key={i} className="flex flex-col gap-y-4">
              {group.map((item, index) => (
                <a
                  key={index}
                  href={item.url}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 group min-w-0 max-w-full"
                >
                  <div key={index} className="flex items-center space-x-2 min-w-0 flex-1">
                    {item.icon ? (
                      <div className="shrink-0">{item.icon}</div>
                    ) : (
                      <div className="shrink-0">
                        <DownloadIcon />
                      </div>
                    )}
                    <span className="text-sm hover:underline truncate">{item.text}</span>
                  </div>
                </a>
              ))}
            </div>
          );
        })}
      </div>
    </section>
  );
}
